import { Module } from '../../types'

export const createDigitalGiftSingleVariantConfiguration = (): Module[] => {
  return [
    {
      __typename: 'ModuleTwoColumn',
      left: [{ __typename: 'ModuleImages' }],
      right: [
        { __typename: 'ModuleTitle' },
        { __typename: 'ModuleRating' },
        { __typename: 'ModulePrice' },
        { __typename: 'ModulePills' },
        { __typename: 'ModuleKlarnaInfo' },
        { __typename: 'ModuleSellingPoints' },
        { __typename: 'ModuleSelectCard' },
        { __typename: 'ModuleMoreInfo' },
      ],
      ratio: '50/50',
    },
  ]
}
